export const RoutePath = {
  Root: '/',
  SomethingWentWrong: '/something-went-wrong',
  SignedOut: '/signed-out',
  AuthCallback: '/auth/callback',
  Home: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/home`
      : '/participation/:participationId/home',
  ParticipationTask: (
    participationId?: string,
    activityName?: string,
    options?: { backTo?: 'schedule' }
  ) =>
    participationId && activityName
      ? `/participation/${participationId}/tasks/${activityName}${
          options?.backTo ? `?backTo=${options.backTo}` : ''
        }`
      : '/participation/:participationId/tasks/:activityName',
  Schedule: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/schedule`
      : '/participation/:participationId/schedule',
  ProtocolStart: `/protocol/:protocolId/start`,
  StudyInfo: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/info`
      : '/participation/:participationId/info',
  SystemInfoStandalone: '/system-info',
  SystemInfoWithLayout: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/system-info`
      : '/participation/:participationId/system-info',
  StudyChoice: '/study-choice',
  DevDebugStandalone: '/dev-debug',
  DevDebugWithLayout: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/dev-debug`
      : '/participation/:participationId/dev-debug',
  DevDataExportStandalone: '/dev-data-export',
  DevDataExportWithLayout: (participationId?: string) =>
    participationId
      ? `/participation/${participationId}/dev-data-export`
      : '/participation/:participationId/dev-data-export',
  // Any other path under a participation; ranks below every route above.
  ParticipationNotFound: '/participation/:participationId/*',
  ProtocolEditWithoutId: '/protocol-editor',
  ProtocolList: '/protocols',
  Brands: '/brands',
  ProtocolEdit: (protocolId?: string) =>
    protocolId ? `/protocol/${protocolId}/edit` : '/protocol/:protocolId/edit',
  NotificationTemplatesMatrix: (protocolId?: string) =>
    `/protocol/${protocolId ?? ':protocolId'}/notification-templates`,
  NotificationTemplateEditor: (
    protocolId?: string,
    notificationTemplateId?: string,
    channel?: string,
    locale?: string
  ) =>
    `/protocol/${protocolId ?? ':protocolId'}/notification-templates/${notificationTemplateId ?? ':notificationTemplateId'}/${channel ?? ':channel'}/${locale ?? ':locale'}`,
  DevDemo: '/dev-demo',
} as const;

// Routes a participation may reach while its status is not `active`. Includes the
// participation home, which renders the enrollment landing for pre-active
// participations. From any other route a non-active participation is redirected to
// `/study-choice`, which navigates to participation home.
export const routesAvailableWhenNotActive = [
  RoutePath.Home(),
  RoutePath.ParticipationTask(),
  RoutePath.ProtocolStart,
  RoutePath.StudyChoice,
  RoutePath.SystemInfoStandalone,
  RoutePath.DevDebugStandalone,
  RoutePath.DevDebugWithLayout(),
  RoutePath.DevDataExportStandalone,
  RoutePath.DevDataExportWithLayout(),
  RoutePath.ProtocolEditWithoutId,
  RoutePath.ProtocolList,
  RoutePath.ProtocolEdit(),
  RoutePath.NotificationTemplatesMatrix(),
  RoutePath.NotificationTemplateEditor(),
  RoutePath.DevDemo,
] as const;
